module.exports = __webpack_public_path__ + "static/media/search.cea3d219.svg";